module.exports = __webpack_public_path__ + "static/media/CAM_UT_01.b836aabd.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/clothes/shirt/CAM_UT_01.png
// module id = 95
// module chunks = 0